import { hashEmailIdentity } from "@/utils/hashIdentity";

export type AnalyticsUserType = "summit" | "pairing";

type SummitAnalyticsUser = {
  orgName: string;
  email: string;
};

function setGoogleAnalyticsUser(props: {
  orgName?: string;
  userType: AnalyticsUserType;
  userId?: string;
}) {
  if (typeof gtag !== "function") {
    return;
  }

  const userProperties: Record<string, string> = {
    user_type: props.userType,
  };

  if (props.orgName) {
    userProperties.org = props.orgName;
  }

  gtag("set", "user_properties", userProperties);

  const measurementId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
  if (props.userId && measurementId) {
    gtag("config", measurementId, { user_id: props.userId });
  }
}

export async function identifySummitUserForGoogleAnalytics(
  currentUser: SummitAnalyticsUser,
) {
  if (!currentUser.email) {
    return;
  }

  setGoogleAnalyticsUser({
    orgName: currentUser.orgName,
    userType: "summit",
    userId: await hashEmailIdentity(currentUser.email),
  });
}

export async function identifyPairingUserForGoogleAnalytics(props: {
  orgName?: string;
  userId: string;
}) {
  setGoogleAnalyticsUser({
    orgName: props.orgName,
    userType: "pairing",
    userId: await hashEmailIdentity(props.userId),
  });
}

export function resetGoogleAnalyticsUser() {
  if (typeof gtag !== "function") {
    return;
  }

  gtag("set", "user_properties", {
    org: "",
    user_type: "",
  });

  const measurementId = import.meta.env.VITE_GOOGLE_ANALYTICS_ID;
  if (measurementId) {
    gtag("config", measurementId, { user_id: null });
  }
}
